import { Box, Button, Typography } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate(); 

    return (
        <>
        <Box sx={{display:'flex', justifyContent:'center', marginTop:'64px'}}>
            <Box sx={{display:'flex', alignItems:'center'}}>
                <img src={process.env.PUBLIC_URL + '/inf-logo.svg'} alt='logo' style={{width:'55px', height:'45x'}}/>
                <img src={process.env.PUBLIC_URL + '/inf-logo-text.svg'} alt='logo' style={{height:'45px', marginLeft:'8px'}}/>
            </Box>
        </Box>
            <Box sx={{
                p: '20px',
                textAlign: 'center',
            }}>
                <Typography variant='h1' color='error' fontWeight="bold">Oh nee, hier is iets misgegaan!</Typography>
                <Box sx={{
                    p:'50px',
                    margin:'auto',
                    width:'1000px',
                    textAlign: 'center',
                }}>
                <Typography variant='h5' fontWeight='bold' textAlign='center'>
                    Webpagina niet gevonden.
                    </Typography>
                    <Box sx={{
                        display:'flex',
                        justifyContent:'center',
                        p:'50px'
                    }}>
                        <Button variant='contained' color='secondary' onClick={() => navigate('/projects')}>Keer terug naar website</Button>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default NotFound;
